<template>
    <div>
        <b-modal v-model="geocodeVisible" size="xl" ok-only>
            <h1>Geokoda</h1>
            <geocode :place="currGeoCodePlace" @geocoded="onGeoCoded($event)"></geocode>
        </b-modal>
        <b-card v-if="missinggeos && missinggeos.length > 0" class="missinggeos">
            <b-card-title>
                <h5>Saknade geokodningar <b-badge variant="danger" >{{ missinggeos.length }}</b-badge></h5>
                <slot></slot>
            </b-card-title>
            <b-card-body>
                <!-- {{ places }} -->
                <b-row v-for="(mg, i) in missinggeos" :key="i">
                    <b-button block variant="outline-secondary" @click="geoCode(mg.place)" title="Geokoda denna adress">{{ getText(mg.place) }}</b-button>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import geocode from './geocode.vue';

export default {
    name: 'missinggeos',
    props: { missinggeos: Array },
    components: { geocode},
    data() {
        return {
            geocodeVisible:false,
            currGeoCodePlace:null,
        }
    },
    methods: {
        getText(p) {
            return `${p.street},${p.city}`;
        },
        geoCode(p) {
            this.currGeoCodePlace=p;
            this.geocodeVisible = true;
        },
        onGeoCoded(ev) {
            //Just geocoded booking with id in ev            
            this.geocodeVisible = false;
            this.$emit('geocoded',ev);
        },        
    }
}

</script>
<style>
.missinggeos {
    background-color: rgb(250, 167, 167);
}
</style>